import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';
import swal from 'sweetalert';
import { AppInsights } from "applicationinsights-js"

// import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.less';
// Vue.use(Antd);

import '../node_modules/@fortawesome/fontawesome-pro/css/all.css';
import './theme/bundle.scss';

import 'nprogress/nprogress.css';
import '../node_modules/vue2-datepicker/index.css';

import RolePermission from "../src/plugins/rolePermissions"
import ReadOnlyPermission from "../src/plugins/readOnlyPermission"
import Vue2Filters from 'vue2-filters';
Vue.use(Vue2Filters);

import 'vuejs-noty/dist/vuejs-noty.css';
import VueNoty from 'vuejs-noty';
Vue.use(VueNoty, {
  theme: 'bootstrap-v4',
  progressBar: false,
  timeout: 2000
});

import * as filters from '@plugins/filters';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import VeeValidate from 'vee-validate';
import './plugins/element.js'

Vue.use(VeeValidate, {
  fieldsBagName: 'veeValidateFields',
});

Vue.config.productionTip = false;

Vue.use(RolePermission);
Vue.use(ReadOnlyPermission);
AppInsights.downloadAndSetup({ instrumentationKey: process.env.VUE_APP_appInsightsInstrumentationKey });

Vue.config.errorHandler = function (err, vm, info) {
  var errorMessage = 'An unhandled error has occurred.  Error: ' + '  ' + err + '; Info: ' + info;
  AppInsights.trackException(errorMessage);
}

window.addEventListener('unhandledrejection', function (err) {
  var errorMessage = 'An unhandled error has occurred. \n\n' + '  ' + err.reason.message;
  if(err.reason.stack) {
    errorMessage +=   '\n\nInfo: ' + err.reason.stack.replace("Error: Error:","");
  }
  swal({title: 'Error',text: errorMessage, icon: 'error', button: true, dangerMode: true,});
  AppInsights.trackException(errorMessage);
});

var app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');

if (window.Cypress) {
  window.__app__ = app;
}